enum CompetitorsPriceRateAlertRuleCalculation {
    INCREASE = "INCREASE",
    DECREASE = "DECREASE",
    INCREASE_AND_DECREASE = "INCREASE_AND_DECREASE",
}

export default CompetitorsPriceRateAlertRuleCalculation;